import { useEffect, useState } from "react";
import deathApi from "../../../../apis/death.api";

export default function useFetchPasswords() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [passwordList, setPasswordList] = useState(null);

  const fetchPasswords = async () => {
    try {
      setLoading(true);
      setError(null); // Reset error on new fetch
      const ID = localStorage.getItem("accessId");
      const otp = localStorage.getItem("otp");
      console.log("infooooo", ID, otp);
      const data = await deathApi.fetchPasswords(otp, ID);
      console.log("dataaaaaaa", data);
      setPasswordList(data); // Actually set the data you received
    } catch (error) {
      setError(error.message || "Failed to fetch passwords");
      console.error("Error fetching passwords:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPasswords();
  }, []);

  return { loading, error, passwordList }; // Return passwordList so it can be used by components
}
